export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/news-3.99feddc3-fc738f.png";